import React from "react";
import { useNavigate } from "react-router-dom";
import { Building2, ArrowRight, Users as UsersIcon } from "lucide-react";
import { StatusBadge } from "../../ui";

/**
 * RecentInstitutes — Table card showing the latest institutes.
 */
const RecentInstitutes = ({ institutes = [] }) => {
  const navigate = useNavigate();

  return (
    <div className="sa-card">
      <div className="sa-card-head">
        <div className="sa-card-head-left">
          <div className="sa-card-icon blue"><Building2 size={18} /></div>
          <div>
            <div className="sa-card-title">Recent Institutes</div>
            <div className="sa-card-subtitle">Latest tenant registrations</div>
          </div>
        </div>
        <button className="sa-card-action" onClick={() => navigate("/sa/institutes")}>
          View all <ArrowRight size={14} />
        </button>
      </div>
      <div className="sa-card-body sa-card-body--table">
        {institutes.length === 0 ? (
          <div className="sa-empty">No institutes yet</div>
        ) : (
          <table className="sa-mini-table">
            <thead>
              <tr>
                <th>Institute</th>
                <th>Plan</th>
                <th>Students</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {institutes.map((inst) => (
                <tr
                  key={inst._id}
                  className="sa-mini-table__row--clickable"
                  onClick={() => navigate(`/sa/institutes/${inst._id}`)}
                >
                  <td>
                    <div className="sa-inst-name">
                      <div className="sa-inst-avatar">{inst.name?.[0] || "?"}</div>
                      <div>
                        <div className="sa-inst-name__text">{inst.name}</div>
                        <div className="sa-inst-name__email">{inst.email}</div>
                      </div>
                    </div>
                  </td>
                  <td>{inst.plan || "Free"}</td>
                  <td>
                    <span className="sa-count"><UsersIcon size={12} /> {inst.studentCount ?? 0}</span>
                  </td>
                  <td>
                    <StatusBadge status={inst.status || "active"}>{inst.status || "Active"}</StatusBadge>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default RecentInstitutes;
